import { EPaymentFrequency } from '@if/core/types'
import { ControlledSelect, ControlledTextField, useTranslatedOptionEnum } from '@if/mui'
import { Grid, Stack, Typography } from '@mui/material'
import { useMemo } from 'react'
import { Control, FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { NewLoanDtoSchemaType } from './loan-form-schema'

interface Props<TFieldValues extends FieldValues> {
  control: Control<NewLoanDtoSchemaType, TFieldValues>
}

const RepaymentConfigInputRow = <TFieldValues extends FieldValues = FieldValues>({ control }: Props<TFieldValues>) => {
  const { t } = useTranslation()
  const paymentFrequencies = useMemo(() => [EPaymentFrequency.Monthly, EPaymentFrequency.BiWeekly], [])
  const paymentPlanOptions = useTranslatedOptionEnum('EPaymentFrequency', paymentFrequencies, 'enum')

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{t('loan.repaymentConfig.title')}</Typography>
        </Stack>
      </Grid>
      <Grid size={6}>
        <ControlledSelect
          control={control}
          name="loanData.repaymentConfig.frequency"
          label={t('loan.repaymentConfig.frequency')}
          options={paymentPlanOptions}
        />
      </Grid>
      <Grid size={6}>
        <ControlledTextField
          control={control}
          name="loanData.repaymentConfig.amount"
          label={t('loan.repaymentConfig.amount')}
          type="number"
        />
      </Grid>
    </Grid>
  )
}

export default RepaymentConfigInputRow
